import { render, staticRenderFns } from "./NotificationEventAuditLogForm.vue?vue&type=template&id=90a3786c&"
import script from "./NotificationEventAuditLogForm.vue?vue&type=script&lang=js&"
export * from "./NotificationEventAuditLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports